var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportStop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V4Zm8 0h-6v2h6V4Zm-2 4h-4v2h4V8Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 7c.64-.64 1.509-1 2.414-1h5.172A3.414 3.414 0 0 1 12 9.414V18a2 2 0 0 1-1 1.732v.768a1.5 1.5 0 0 1-3 0V20H4v.5a1.5 1.5 0 0 1-3 0v-.768A2 2 0 0 1 0 18V9.414C0 8.51.36 7.64 1 7Zm1 3h8v4H2v-4Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4h6v2h-6V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8h4v2h-4V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12h-2v8h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportStop);
export default __webpack_public_path__ + "static/media/ic_action_transport_stop.c12a5f91ebbb7ec3e65dbf328d405d4e.svg";
export { ForwardRef as ReactComponent };